<section class="h1-plus-lead" *ngIf="title || lead">
  <div class="container">
    <h1 *ngIf="title">{{ title }}</h1>
    <p *ngIf="lead" [innerHTML]="lead"></p>
  </div>
</section>
